<template>
  <div class="float-right">
    <b-modal
        ref="create-modal"
        :title="$t('modal.segment.add_new_segment')"
        size="xl">
      <div class="w-100 d-flex justify-content-center">
        <div v-if="step === 1" class="w-100 d-flex flex-column align-items-center justify-content-center">
          <h5 class="text-primary mb-3">{{$t('btn.segment.choose_segment_type')}}</h5>
          <div class="d-flex justify-content-center w-100">
            <b-button @click="setIsStatic(true)" type="button" class="w-25 mr-2 btn-secondary" :class="{'btn-success': segment.isStatic === true}">{{$t('btn.segment.set_static')}}</b-button>
            <b-button @click="setIsStatic(false)" type="submit" class="w-25 btn-secondary" :class="{'btn-success': segment.isStatic === false}">{{$t('btn.segment.set_dynamic')}}</b-button>
          </div>
        </div>

        <div v-if="step === 2" class="w-100 d-flex flex-column align-items-center justify-content-center">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <h5 class="text-primary mr-2">{{$t('btn.segment.add_new_rule')}}</h5>
            <b-form-select
                v-model="rule"
                :options="options.ruleType">
            </b-form-select>
            <b-button @click="setRule" type="button" variant="success" class="w-25 ml-2">{{$t('btn.segment.add_new_rule')}}</b-button>
          </div>
          <div ref="rulesContainer" class="w-100"></div>
        </div>

        <div v-if="step === 3" class="w-100 d-flex align-items-center justify-content-center">
          <h5 class="text-primary mr-3">{{$t('btn.segment.choose_segment_name')}}</h5>
          <b-form-input v-model="segment.name"></b-form-input>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2"  @click="hideModal">{{$t('btn.cancel')}}</b-button>
            <b-button variant="warning" class="mr-2" @click="setStep(step === 2 ? 1 : 2)" :disabled="step === 1">{{$t('btn.segment.prev_step')}}</b-button>
            <b-button
                v-if="step === 1 || step === 2"
                variant="primary"
                @click="setStep(step === 1 ? 2 : 3)"
                :disabled="(step === 1 && segment.isStatic === null) || (step === 2 && !rules.length)">
              {{$t('btn.segment.next_step')}}
            </b-button>
            <b-button v-if="step === 3" variant="primary" @click="saveSegment" :disabled="!segment.name">{{$t('btn.segment.next_step')}}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import GenderRule from "./rules/GenderRule";
import CountryRule from "./rules/CountryRule";
import OptInRule from "./rules/OptInRule";
import LocaleRule from "./rules/LocaleRule";
import TagRule from "./rules/TagRule";
import RegisteredRule from "./rules/RegisteredRule";
import Vue from 'vue';
import moment from "moment";
import {requiredIf} from "vuelidate/lib/validators";
import {
  genderRule,
  countryRule,
  userSegment,
  optInRule,
  tagRule,
  localeRule,
  registeredRule,
  paymentTimesDepositedRule,
  paymentTotalDepositedRule,
  paymentBalanceRule,
  paymentRevenueRule,
  gameRule,
    groupRule
} from "../../../common/constants/userSegment";
import PaymentTimesDepositedRule from "./rules/PaymentTimesDepositedRule";
import PaymentTotalDepositedRule from "./rules/PaymentTotalDepositedRule";
import GameRule from "./rules/GameRule";
import PaymentBalanceRule from "./rules/PaymentBalanceRule";
import PaymentRevenueRule from "./rules/PaymentRevenueRule";
import GroupRule from "./rules/GroupRule";

export default {
  props: {
    routeParams: Object
  },
  data() {
    return {
      ruleForms: {
        gender: {
          value: []
        },
        country: {
          countries: [],
          operation: ''
        },
        locale: {
          locales: [],
          operation: ''
        },
        tag: {
          tags: [],
          operation: ''
        },
        optIn: {
          agreements: [],
          operation: '',
          country: {
            countries: [],
            operation: ''
          }
        },
        registered: {
          operation: null,
          dateFrom: null,
          dateTo: null,
          daysFrom: null,
          daysTo: null,
        },
        paymentTimesDeposited: {
          timeOperation: null,
          amount: null,
          currency: null,
          condition: null,
          dateFrom: null,
          dateTo: null,
          daysFrom: null,
          daysTo: null,
        },
        paymentTotalDeposited: {
          timeOperation: null,
          amount: null,
          condition: null,
          dateFrom: null,
          dateTo: null,
          daysFrom: null,
          daysTo: null,
        },
        paymentBalance: {
          amount: null,
          currency: null,
          operation: null,
        },
        paymentRevenue: {
          timeOperation: null,
          amount: null,
          currency: null,
          condition: null,
          dateFrom: null,
          dateTo: null,
          daysFrom: null,
          daysTo: null,
        },
        game: {
          timeOperation: null,
          currency: null,
          amount: null,
          condition: null,
          dateFrom: null,
          dateTo: null,
          daysFrom: null,
          daysTo: null,
        },
        group: {
          groupId: '',
          operation: ''
        },
      },
      segmentRules: userSegment,
      step: 1,
      rule: '',
      chosenSegmentType: '',
      rules: [],
      segment: {
        name: '',
        isStatic: null,
        rules: {
          rules: [

          ]
        }
      },
      options: {
        ruleType: [
          { value: null, text: this.$t('btn.segment.set_rule_placeholder'), disabled: true}
        ]
      }
    };
  },
  computed: {
    ...mapState({
      newSegmentParams: state => state.crmDashboardStore.newSegmentParams
    }),
  },
  validations: {
    ruleForms: {
      gender: {
        value: { required: requiredIf(function () {
            return this.rules.includes(userSegment.gender);
          })
        }
      },
      country: {
        countries: { required: requiredIf(function () {
            return this.rules.includes(userSegment.country);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.country);
          })
        }
      },
      tag: {
        tags: { required: requiredIf(function () {
            return this.rules.includes(userSegment.tag);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.tag);
          })
        }
      },
      locale: {
        locales: { required: requiredIf(function () {
            return this.rules.includes(userSegment.locale);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.locale);
          })
        }
      },
      optIn: {
        agreements: {
          required: requiredIf(function () {
            return this.rules.includes(userSegment.optIn);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.optIn);
          })
        },
        country: {
          countries: { required: requiredIf(function () {
              return this.rules.includes(userSegment.optIn);
            })
          },
          operation: { required: requiredIf(function () {
              return this.rules.includes(userSegment.optIn);
            })
          }
        }
      },
      registered: {
        dateFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.registered) && this.ruleForms.registered.operation === 'BETWEEN_DATES';
          })
        },
        daysFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.registered) && this.ruleForms.registered.operation === 'BETWEEN_DAYS';
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.registered);
          })
        }
      },
      paymentTimesDeposited: {
        dateFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited) && this.ruleForms.paymentTimesDeposited.timeOperation === 'BETWEEN_DATES';
          })
        },
        daysFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited) && this.ruleForms.paymentTimesDeposited.timeOperation === 'BETWEEN_DAYS';
          })
        },
        timeOperation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited);
          })
        },
        amount: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited);
          })
        },
        currency: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited);
          })
        },
        condition: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTimesDeposited);
          })
        }
      },
      paymentTotalDeposited: {
        dateFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTotalDeposited) && this.ruleForms.paymentTotalDeposited.timeOperation === 'BETWEEN_DATES';
          })
        },
        daysFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTotalDeposited) && this.ruleForms.paymentTotalDeposited.timeOperation === 'BETWEEN_DAYS';
          })
        },
        timeOperation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTotalDeposited);
          })
        },
        amount: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTotalDeposited);
          })
        },
        condition: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentTotalDeposited);
          })
        }
      },
      paymentBalance: {
        amount: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentBalance);
          })
        },
        currency: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentBalance);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentBalance);
          })
        }
      },
      paymentRevenue: {
        dateFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue) && this.ruleForms.paymentRevenue.timeOperation === 'BETWEEN_DATES';
          })
        },
        daysFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue) && this.ruleForms.paymentRevenue.timeOperation === 'BETWEEN_DAYS';
          })
        },
        timeOperation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue);
          })
        },
        amount: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue);
          })
        },
        currency: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue);
          })
        },
        condition: { required: requiredIf(function () {
            return this.rules.includes(userSegment.paymentRevenue);
          })
        }
      },
      game: {
        dateFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game) && this.ruleForms.game.timeOperation === 'BETWEEN_DATES';
          })
        },
        daysFrom: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game) && this.ruleForms.game.timeOperation === 'BETWEEN_DAYS';
          })
        },
        timeOperation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game);
          })
        },
        amount: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game);
          })
        },
        currency: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game);
          })
        },
        condition: { required: requiredIf(function () {
            return this.rules.includes(userSegment.game);
          })
        }
      },
      group: {
        groupId: { required: requiredIf(function () {
            return this.rules.includes(userSegment.group);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.group);
          })
        }
      },
    }
  },
  mounted() {
    this.$store.dispatch('root/getTags');

    this.$store.dispatch('userSegment/getRuleTypes').then(resp => {
      resp.data.forEach(rule => {
        this.options.ruleType.push(
          {
            value: rule,
            text: this.$t(`btn.segment.segment_type.${rule}`)
          }
        );
      });
    });

    // GENDER RULE
    this.$on('selectedGender', (e) => {
      this.$v.ruleForms.gender.value.$touch();
      this.setGenderRule(e);
    });

    this.$on('removeGenderRule', (e) => {
      this.removeComponent(e);
    });

    // COUNTRY RULE
    this.$on('selectedCountry', (e) => {
      this.$v.ruleForms.country[e.type].$touch();

      this.setCountryRule(e);
    });

    this.$on('removeCountryRule', (e) => {
      this.removeComponent(e);
    });

    // TAG RULE
    this.$on('selectedTag', (e) => {
      this.$v.ruleForms.tag[e.type].$touch();

      this.setTagRule(e);
    });

    this.$on('removeTagRule', (e) => {
      this.removeComponent(e);
    });

    // LOCALE RULE
    this.$on('selectedLocale', (e) => {
      this.$v.ruleForms.locale[e.type].$touch();

      this.setLocaleRule(e);
    });

    this.$on('removeLocaleRule', (e) => {
      this.removeComponent(e);
    });

    // OPT IN RULE
    this.$on('selectedOptIn', (e) => {
      this.setOptInRule(e);
    });

    this.$on('removeOptInRule', (e) => {
      this.removeComponent(e);
    });

    // REGISTERED RULE
    this.$on('selectedRegistered', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.registered[e.type].$touch();
      }

      this.setRegisteredRule(e);
    });

    this.$on('removeRegisteredRule', (e) => {

      this.removeComponent(e);
    });

    // REGISTERED RULE
    this.$on('selectedRegistered', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.registered[e.type].$touch();
      }

      this.setRegisteredRule(e);
    });

    this.$on('removeRegisteredRule', (e) => {

      this.removeComponent(e);
    });

    // PAYMENT Times DEPOSITED RULE
    this.$on('selectedPaymentTimesDeposited', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.paymentTimesDeposited[e.type].$touch();
      }

      this.setTimesDepositedRule(e);
    });

    this.$on('removePaymentTimesDepositedRule', (e) => {

      this.removeComponent(e);
    });

    // PAYMENT Total DEPOSITED RULE
    this.$on('selectedPaymentTotalDeposited', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.paymentTotalDeposited[e.type].$touch();
      }

      this.setTotalDepositedRule(e);
    });

    this.$on('removePaymentTotalDeposited', (e) => {

      this.removeComponent(e);
    });

    // PAYMENT BALANCE RULE
    this.$on('selectedPaymentBalance', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.paymentBalance[e.type].$touch();
      }

      this.setPaymentBalanceRule(e);
    });

    this.$on('removePaymentBalance', (e) => {

      this.removeComponent(e);
    });

    // PAYMENT REVENUE RULE
    this.$on('selectedPaymentRevenue', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.paymentRevenue[e.type].$touch();
      }

      this.setPaymentRevenueRule(e);
    });

    this.$on('removePaymentRevenue', (e) => {

      this.removeComponent(e);
    });

    // GAME
    this.$on('selectedGame', (e) => {
      if(e.type !== 'dateTo' && e.type !== 'daysTo') {
        this.$v.ruleForms.game[e.type].$touch();
      }

      this.setGameRule(e);
    });

    this.$on('removeGame', (e) => {

      this.removeComponent(e);
    });

    // GROUP
    this.$on('selectedGroup', (e) => {
      this.$v.ruleForms.group[e.type].$touch();

      this.setGroupRule(e);
    });

    this.$on('removeGroup', (e) => {
      this.removeComponent(e);
    });

    if(this.newSegmentParams) {
      this.segment.isStatic = true;
      this.setStep(2);

      for (const [key] of Object.entries(this.newSegmentParams.segments)) {
        this.rule = key;
        this.setRule();
      }

      // this.$store.commit('crmDashboardStore/newSegmentParams', null);
    }
  },
  methods: {
    removeComponent(data) {
      data.component.$destroy();
      this.$refs.rulesContainer.removeChild(data.component.$el);

      this.rules = this.rules.filter(rule => {
        return rule !== data.rule;
      });

      this.segment.rules.rules = this.segment.rules.rules.filter(rule => {
        return rule.type !== data.rule;
      });
    },
    setRule() {
      let ComponentClass;
      let instance;

      switch(this.rule) {
        case userSegment.gender:
          ComponentClass = Vue.extend(GenderRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.gender,
              genderForm: this.ruleForms.gender
            }
          });

          break;
        case userSegment.country:
          ComponentClass = Vue.extend(CountryRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.country,
              countryForm: this.ruleForms.country
            }
          });

          break;
        case userSegment.tag:
          ComponentClass = Vue.extend(TagRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.tag,
              tagForm: this.ruleForms.tag
            }
          });

          break;
        case userSegment.locale:
          ComponentClass = Vue.extend(LocaleRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.locale,
              localeForm: this.ruleForms.locale
            }
          });

          break;
        case userSegment.optIn:
          ComponentClass = Vue.extend(OptInRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.optIn,
              optInForm: this.ruleForms.optIn
            }
          });

          break;
        case userSegment.registered:
          ComponentClass = Vue.extend(RegisteredRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.registered,
              registeredForm: this.ruleForms.registered
            }
          });

          break;
        case userSegment.paymentTimesDeposited:
          ComponentClass = Vue.extend(PaymentTimesDepositedRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.paymentTimesDeposited,
              paymentTimesDepositedForm: this.ruleForms.paymentTimesDeposited
            }
          });

          break;
        case userSegment.paymentTotalDeposited:
          ComponentClass = Vue.extend(PaymentTotalDepositedRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.paymentTotalDeposited,
              paymentTotalDepositedForm: this.ruleForms.paymentTotalDeposited
            }
          });

          break;
        case userSegment.paymentBalance:
          ComponentClass = Vue.extend(PaymentBalanceRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.paymentBalance,
              paymentBalanceForm: this.ruleForms.paymentBalance
            }
          });

          break;
        case userSegment.paymentRevenue:
          ComponentClass = Vue.extend(PaymentRevenueRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.paymentRevenue,
              paymentRevenueForm: this.ruleForms.paymentRevenue
            }
          });

          break;
        case userSegment.game:
          ComponentClass = Vue.extend(GameRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.game,
              gameForm: this.ruleForms.game
            }
          });

          break;
        case userSegment.group:
          ComponentClass = Vue.extend(GroupRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.group,
              groupForm: this.ruleForms.group,
              isStaticType: this.segment.isStatic
            }
          });

          break;
      }

      if(!this.rules.includes(this.rule)) {
        this.rules.push(this.rule);

        if(this.rule === userSegment.gender) {
          this.segment.rules.rules.push(
              genderRule
          );
        }

        if(this.rule === userSegment.country) {
          this.segment.rules.rules.push(
              countryRule
          );
        }

        if(this.rule === userSegment.tag) {
          this.segment.rules.rules.push(
              tagRule
          );
        }

        if(this.rule === userSegment.locale) {
          this.segment.rules.rules.push(
              localeRule
          );
        }

        if(this.rule === userSegment.optIn) {
          this.segment.rules.rules.push(
              optInRule
          );
        }

        if(this.rule === userSegment.registered) {
          this.segment.rules.rules.push(
             registeredRule
          );
        }

        if(this.rule === userSegment.paymentTimesDeposited) {
          this.segment.rules.rules.push(
              paymentTimesDepositedRule
          );
        }

        if(this.rule === userSegment.paymentTotalDeposited) {
          this.segment.rules.rules.push(
              paymentTotalDepositedRule
          );
        }

        if(this.rule === userSegment.paymentBalance) {
          this.segment.rules.rules.push(
              paymentBalanceRule
          );
        }

        if(this.rule === userSegment.paymentRevenue) {
          this.segment.rules.rules.push(
              paymentRevenueRule
          );
        }

        if(this.rule === userSegment.game) {
          this.segment.rules.rules.push(
              gameRule
          );
        }

        if(this.rule === userSegment.group) {
          this.segment.rules.rules.push(
              groupRule
          );
        }

        setTimeout(() => {
          instance.$mount();

          this.$refs.rulesContainer.appendChild(instance.$el);
          this.rule = '';
        }, 100);
      }
    },
    setGenderRule(e) {
      this.ruleForms.gender.value = e.val;
      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.gender) {
          rule.allowedGenders = e.val.map(gender => {
            return gender.value;
          });
        }
      });
    },
    setCountryRule(e) {
      this.ruleForms.country.countries = e.countries.map(country => {
        return country.value;
      });
      this.ruleForms.country.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.country) {
          rule.countries = e.countries.map(country => {
            return country.value;
          });

          rule.operation = e.operation;
        }
      });
    },
    setTagRule(e) {
      this.ruleForms.tag.tags = e.tags;
      this.ruleForms.tag.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.tag) {
          rule.tags = e.tags.map(tag => {
            return tag.value;
          });

          rule.operation = e.operation;
        }
      });
    },
    setLocaleRule(e) {
      this.ruleForms.locale.locales = e.locale;
      this.ruleForms.locale.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.locale) {
          rule.locales = e.locale.map(locale => {
            return locale.value;
          });

          rule.operation = e.operation;
        }
      });
    },
    setOptInRule(e) {
      this.ruleForms.optIn.country.countries = e.country.countries;
      this.ruleForms.optIn.country.operation = e.country.operation;
      this.ruleForms.optIn.operation = e.operation;
      this.ruleForms.optIn.agreements = e.agreements;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.optIn) {
          rule.country.countries = e.country.countries.map(country => {
            return country.value;
          });

          rule.country.operation = e.country.operation;

          rule.agreements = e.agreements.map(agreement => {
            return agreement.value;
          });

          rule.operation = e.operation;
        }
      });
    },
    setRegisteredRule(e) {
      this.ruleForms.registered.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.registered.dateTo = e.dateFrom.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.registered.daysFrom = e.daysFrom;
      this.ruleForms.registered.daysTo = e.daysTo;
      this.ruleForms.registered.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.registered) {
          rule.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
          rule.dateTo = e.dateTo.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
          rule.daysFrom = e.daysFrom ? Number(e.daysFrom) : null;
          rule.daysTo = e.daysTo ? Number(e.daysTo) : null;
          rule.operation = e.operation;
        }
      });
    },
    setTimesDepositedRule(e) {
      this.ruleForms.paymentTimesDeposited.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentTimesDeposited.dateTo = e.dateFrom.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentTimesDeposited.daysFrom = e.daysFrom ? e.daysFrom : null;
      this.ruleForms.paymentTimesDeposited.daysTo = e.daysTo ? e.daysTo : null;
      this.ruleForms.paymentTimesDeposited.amount = e.amount ? Number(e.amount) : null;
      this.ruleForms.paymentTimesDeposited.currency = e.currency ? e.currency : null;
      this.ruleForms.paymentTimesDeposited.condition = e.condition ? e.condition : null;
      this.ruleForms.paymentTimesDeposited.timeOperation = e.timeOperation ? e.timeOperation : null;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.paymentTimesDeposited) {
          rule.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
          rule.dateTo = e.dateTo.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
          rule.daysFrom = e.daysFrom ? Number(e.daysFrom) : null;
          rule.daysTo = e.daysTo ? Number(e.daysTo) : null;
          rule.timeOperation = e.timeOperation;
          rule.amount = Number(e.amount);
          rule.condition = e.condition;
          rule.currency = e.currency;
        }
      });
    },
    setTotalDepositedRule(e) {
      this.ruleForms.paymentTotalDeposited.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentTotalDeposited.dateTo = e.dateFrom.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentTotalDeposited.daysFrom = e.daysFrom ? e.daysFrom : null;
      this.ruleForms.paymentTotalDeposited.daysTo = e.daysTo ? e.daysTo : null;
      this.ruleForms.paymentTotalDeposited.amount = e.amount ? e.amount : null;
      this.ruleForms.paymentTotalDeposited.condition = e.condition ? e.condition : null;
      this.ruleForms.paymentTotalDeposited.timeOperation = e.timeOperation ? e.timeOperation : null;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.paymentTotalDeposited) {
          rule.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
          rule.dateTo = e.dateTo.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
          rule.daysFrom = e.daysFrom ? Number(e.daysFrom) : null;
          rule.daysTo = e.daysTo ? Number(e.daysTo) : null;
          rule.timeOperation = e.timeOperation;
          rule.amount = e.amount;
          rule.condition = e.condition;
        }
      });
    },
    setPaymentBalanceRule(e) {
      this.ruleForms.paymentBalance.amount = e.amount ? e.amount : null;
      this.ruleForms.paymentBalance.currency = e.currency ? e.currency : null;
      this.ruleForms.paymentBalance.operation = e.operation ? e.operation : null;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.paymentBalance) {
          rule.amount = e.amount;
          rule.operation = e.operation;
          rule.currency = e.currency;
        }
      });
    },
    setGameRule(e) {
      this.ruleForms.game.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.game.dateTo = e.dateFrom.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.game.daysFrom = e.daysFrom ? e.daysFrom : null;
      this.ruleForms.game.daysTo = e.daysTo ? e.daysTo : null;
      this.ruleForms.game.amount = e.amount ? Number(e.amount): null;
      this.ruleForms.game.condition = e.condition ? e.condition : null;
      this.ruleForms.game.timeOperation = e.timeOperation ? e.timeOperation : null;
      this.ruleForms.game.currency = e.currency;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.game) {
          rule.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
          rule.dateTo = e.dateTo.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
          rule.daysFrom = e.daysFrom ? Number(e.daysFrom) : null;
          rule.daysTo = e.daysTo ? Number(e.daysTo) : null;
          rule.timeOperation = e.timeOperation;
          rule.amount = e.amount ? Number(e.amount) : null;
          rule.condition = e.condition;
          rule.currency = e.currency;
        }
      });
    },
    setPaymentRevenueRule(e) {
      this.ruleForms.paymentRevenue.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentRevenue.dateTo = e.dateFrom.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
      this.ruleForms.paymentRevenue.daysFrom = e.daysFrom ? e.daysFrom : null;
      this.ruleForms.paymentRevenue.daysTo = e.daysTo ? e.daysTo : null;
      this.ruleForms.paymentRevenue.amount = e.amount ? e.amount : null;
      this.ruleForms.paymentRevenue.currency = e.currency ? e.currency : null;
      this.ruleForms.paymentRevenue.condition = e.condition ? e.condition : null;
      this.ruleForms.paymentRevenue.timeOperation = e.timeOperation ? e.timeOperation : null;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.paymentRevenue) {
          rule.dateFrom = e.dateFrom.startDate ? moment(e.dateFrom.startDate).format('YYYY-MM-DD') : null;
          rule.dateTo = e.dateTo.startDate ? moment(e.dateTo.startDate).format('YYYY-MM-DD') : null;
          rule.daysFrom = e.daysFrom ? Number(e.daysFrom) : null;
          rule.daysTo = e.daysTo ? Number(e.daysTo) : null;
          rule.timeOperation = e.timeOperation;
          rule.amount = e.amount;
          rule.condition = e.condition;
          rule.currency = e.currency;
        }
      });
    },
    setGroupRule(e) {
      this.ruleForms.group.groupId = e.groupId;
      this.ruleForms.group.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.group) {
          rule.groupId = e.groupId;
          rule.operation = e.operation;
        }
      });
    },
    setStep(value) {
      if(value === 1) {
        this.step = 1;
        return;
      }

      if(value === 2) {
        this.step = value;

        this.rules.forEach(rule => {
          this.rule = rule;
          this.setRule();
        });
        return;
      }

      if(!this.$v.$invalid) {
        this.step = 3;
      }

      if(this.$v.$invalid) {
        this.$v.$touch();
      }
    },
    setIsStatic(value) {
      this.segment.isStatic = value;
    },
    saveSegment() {
      this.$store.dispatch('userSegment/saveSegment', this.segment).then(() => {
        this.hideModal();
        this.$parent.$emit('refreshGrid');
      });
    },
    openModal() {
      this.$refs['create-modal'].show()
    },
    hideModal() {
      console.log('hide')
      this.$store.commit('crmDashboardStore/newSegmentParams', null);

      this.$refs['create-modal'].hide();
    }
  }
}
</script>
